var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineIconAsianFoodNoodlesBowl({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2.9 6.75 19.5-6M2.9 8.25l19.5-3M7.87 7.49a2.79 2.79 0 0 1-.08 2.6l-.9 1.57a5.33 5.33 0 0 0-.33 2.59M11.28 7a2.76 2.76 0 0 1 .26 3.12l-.9 1.57a5.33 5.33 0 0 0-.33 2.59m4.35-7.84a2.82 2.82 0 0 1 .75 3.65l-.89 1.57a5.33 5.33 0 0 0-.33 2.59",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.35 14.25a.75.75 0 0 0-.7 1 11.58 11.58 0 0 0 6.5 5.79v1.46a.76.76 0 0 0 .75.75h6a.75.75 0 0 0 .75-.75v-1.43a11.51 11.51 0 0 0 6.5-5.79.75.75 0 0 0-.69-1Z",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconAsianFoodNoodlesBowl);
export default __webpack_public_path__ + "static/media/streamline-icon-asian-food-noodles-bowl.7eec98fc.svg";
export { ForwardRef as ReactComponent };